<template>
<div>
    <h1 class="mb-4 text-gray-500">{{website}} Downloader</h1>
    <client-only>
        <template #fallback>
            <el-card shadow="never" :body-style="{padding: '0'}" class="mb-4">
                <div style="height: 100px" class="flex items-center justify-center">
                    <ElIconLoading :width="20" class="mr-2"/> 
                    Loading the app
                </div>
            </el-card>
        </template>
        <downloader></downloader>
    </client-only>
    <el-card shadow="never" class="mb-4" v-if="!isLoading && downloaderInfo.id">
        <div v-html="downloaderInfo.data.content"></div>
    </el-card>
</div>
</template>

<script setup>
const route = useRoute()
const {PROJECT, DOWNLOADER} = useConstants()
var downloaderInfo = reactive({
    id: '',
    data: {
        title: '',
        content: ''
    }
})
const isLoading = ref(true)
const { data } = await useCms('/content/query', {
    method: 'POST',
    body: {
        filters: {
            type: DOWNLOADER,
            project: PROJECT,
            'data.downloader': route.params.website
        }
    }
})
Object.assign(downloaderInfo, data.value.result.items[0])
isLoading.value = false

const website = computed(() => {
    return route.params.website.split('-')
        .map(segment => segment.charAt(0).toUpperCase() + segment.slice(1))
        .join(' ')
})

useHead({
    title: `${website.value} Downloader`,
    meta: [
        {
            hid: 'description',
            name: 'description',
            content: `${website.value} downloader lets you download videos and photos using chrome extension`,
        }
    ]
})
</script>